module.exports = __webpack_public_path__ + "Icon-americas.4796ee6946036b00c15b6ea512188444.svg";